import { createContext } from 'react';
import { HealthCenterContextType } from './types';

export const HealthCenterContext = createContext<HealthCenterContextType>({} as HealthCenterContextType);
